import { Route, Routes } from 'react-router-dom'
import DealsKRRoutes from 'views/pages/LogisticsKR/LogisticRequests/routes'
import { LogisticianBoard } from './RequestsBoard/LogistianBoard'
import { RequestCars } from './RequestCars/RequestCars'
import RequestDetails from './RequestDetails/RequestDetails'
import { FC } from 'react'

const LogisticRequestsPage: FC = () => (
  <Routes>
    <Route index element={<LogisticianBoard />} />
    <Route path={DealsKRRoutes.relativeListWithTab} element={<LogisticianBoard />} />
    <Route path={DealsKRRoutes.relativeListWithTabAndRequest} element={<LogisticianBoard />} />
    <Route path={DealsKRRoutes.relativeDetails} element={<RequestDetails />} />
    <Route path={DealsKRRoutes.relativeTripCars} element={<RequestCars />} />
  </Routes>
)
export default LogisticRequestsPage
